import React, { useRef, useEffect } from "react";
import html2canvas from "html2canvas";

const BoardingPass = ({ patientData, onGenerate, autoGenerate }) => {
  const frontRef = useRef(null);
  const backRef = useRef(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return `${d.getDate()} ${d
      .toLocaleString("en-US", { month: "short" })
      .toUpperCase()} ${d.getFullYear()}`;
  };

//   const generateImage = async () => {
//     // Capture front
//     const frontCanvas = await html2canvas(frontRef.current, {
//       scale: 3,
//       backgroundColor: "#ffffff",
//       useCORS: true,
//       width: frontRef.current.offsetWidth,
//       height: frontRef.current.offsetHeight,
//     });

//     // Capture back
//     const backCanvas = await html2canvas(backRef.current, {
//       scale: 3,
//       backgroundColor: "#ffffff",
//       useCORS: true,
//       width: backRef.current.offsetWidth,
//       height: backRef.current.offsetHeight,
//     });

//     // Combine both into single canvas
//     const combinedCanvas = document.createElement('canvas');
//     const gap = 60; // gap between front and back (adjust as needed)
    
//     combinedCanvas.width = Math.max(frontCanvas.width, backCanvas.width);
//     combinedCanvas.height = frontCanvas.height + backCanvas.height + gap;
    
//     const ctx = combinedCanvas.getContext('2d');
//     ctx.fillStyle = '#ffffff';
//     ctx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);
    
//     // Draw front at top
//     ctx.drawImage(frontCanvas, 0, 0);
    
//     // Draw back below front with gap
//     ctx.drawImage(backCanvas, 0, frontCanvas.height + gap);

//     // Convert combined canvas to blob
//     const combinedBlob = await new Promise((res) =>
//       combinedCanvas.toBlob(res, "image/png", 1)
//     );

//     onGenerate(combinedBlob);
//   };


  const generateImage = async () => {
  // Capture front
  const frontCanvas = await html2canvas(frontRef.current, {
    scale: 3,
    backgroundColor: "#ffffff",
    useCORS: true,
    width: frontRef.current.offsetWidth,
    height: frontRef.current.offsetHeight,
  });

  // Capture back
  const backCanvas = await html2canvas(backRef.current, {
    scale: 3,
    backgroundColor: "#ffffff",
    useCORS: true,
    width: backRef.current.offsetWidth,
    height: backRef.current.offsetHeight,
  });

  // Combine both into single canvas
  const combinedCanvas = document.createElement('canvas');
  const gap = 80; // gap between front and back for the cutting line
  
  combinedCanvas.width = Math.max(frontCanvas.width, backCanvas.width);
  combinedCanvas.height = frontCanvas.height + backCanvas.height + gap;
  
  const ctx = combinedCanvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);
  
  // Draw front at top
  ctx.drawImage(frontCanvas, 0, 0);
  
  // Draw back below front with gap
  ctx.drawImage(backCanvas, 0, frontCanvas.height + gap);

  // ← ADD CUTTING LINE HERE
  const lineY = frontCanvas.height + (gap / 2);
  
  // Draw scissor icon (optional - using text emoji)
  ctx.font = '40px Arial';
  ctx.fillStyle = '#999';
  ctx.fillText('✂', 20, lineY + 15);
  
  // Draw dashed cutting line
  ctx.strokeStyle = '#999';
  ctx.lineWidth = 3;
  ctx.setLineDash([15, 10]); // dash pattern: 15px line, 10px gap
  ctx.beginPath();
  ctx.moveTo(80, lineY);
  ctx.lineTo(combinedCanvas.width - 20, lineY);
  ctx.stroke();
  ctx.setLineDash([]); // reset to solid line

  // Convert combined canvas to blob
  const combinedBlob = await new Promise((res) =>
    combinedCanvas.toBlob(res, "image/png", 1)
  );

  onGenerate(combinedBlob);
};

  useEffect(() => {
    if (autoGenerate) {
      const timer = setTimeout(() => {
        generateImage();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);


  const styles = {
   pass: {
     width: "800px",
     height: "250px",
     display: "flex",
     background: "#fff",
     borderRadius: "18px",
     overflow: "hidden",
     boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
     fontFamily: "Arial, sans-serif",
   },
   
    /* LEFT SIDE */
    left: {
      flex: 3,
      padding: "10px 15px",
      position: "relative",
    },

    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "18px",
    },

    logo: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },

    logoImg: {
      height: "65px",
    },

    headerCenter: {
      background: "linear-gradient(90deg,#5B9AAD,#4a8091)",
      padding: "8px 18px",
      borderRadius: "6px",
    },

    headerTitle: {
      color: "#fff",
      fontSize: "15px",
      fontWeight: "700",
      letterSpacing: "1px",
      margin: 0,
    },

    location: {
      fontWeight: "700",
      color: "#2c3e50",
      marginTop: "2px",
      marginBottom: "20px",
    },
    
    row: {
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid #dbe5ec",
      paddingBottom: "6px",
      marginBottom: "12px",
    },

    label: {
      width: "140px",
      fontSize: "14px",
      fontWeight: "600",
      color: "#5B9AAD",
    },

    value: {
      fontSize: "16px",
      fontWeight: "700",
      color: "#2c3e50",
    },

    tests: {
      marginTop: "10px",
      fontSize: "14px",
      lineHeight: "1.5",
      fontWeight: "600",
    },

    footer: {
      position: "absolute",
      bottom: "15px",
      left: "30px",
      right: "30px",
      display: "flex",
      justifyContent: "space-between",
      borderTop: "1px solid #5B9AAD",
      paddingTop: "7px",
      fontWeight: "700",
    },

    right: {
      width: "50px",
      minWidth: "150px",
      flexShrink: 0,
      borderLeft: "2px dashed #b0c4d4",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },

    qr: {
      width: "130px",
      height: "160px",
      border: "2px solid #000",
      padding: "1px",
    },

    qrText: {
      fontSize: "12px",
      fontWeight: "700",
      letterSpacing: "1px",
    },

    button: {
      marginTop: "20px",
      width: "800px",
      padding: "14px",
      background: "#5B9AAD",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "700",
      cursor: "pointer",
    },

    back: {
      width: "800px",
      height: "250px",
      display: "flex",
      background: "#fff",
      borderRadius: "18px",
      overflow: "hidden",
      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
      fontFamily: "Arial, sans-serif",
      marginTop: "20px",
    },

    backLeft: {
      flex: 3,
      padding: "12px 18px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      position: "relative",  
    },

    backTopStrip: {
      height: "34px",
      background: "#5B9AAD",
      borderRadius: "10px",
    },

    backContent: {
      flex: 1,
      paddingTop: "6px",
    },

    sectionTitle: {
      fontSize: "14px",
      fontWeight: "700",
      color: "#355f7a",
      marginBottom: "6px",
    },

    bullet: {
      fontSize: "11px",
      marginBottom: "4px",
      color: "#2c3e50",
    },

    contact: {
      fontSize: "11px",
      marginBottom: "3px",
      color: "#2c3e50",
    },

    backBottomStrip: {
      height: "28px",
      background: "#5B9AAD",
      borderRadius: "10px",
    },

    backRight: {
      width: "150px",
      minWidth: "150px",
      borderLeft: "2px dashed #b0c4d4",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },

    backLogoWrap: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      opacity: 0.08,
      pointerEvents: "none",
    },

    backLogoImg: {
      height: "280px",
      width: "900px",
    },
  };

  return (
    <>
      <div ref={frontRef} style={styles.pass}>
        {/* LEFT */}
        <div style={styles.left}>
          <div style={styles.backLogoWrap}>
            <img
              src="/campanylogo.jpeg"
              alt="XRai Logo"
              style={styles.backLogoImg}
              crossOrigin="anonymous"
            />
          </div>
          <div style={styles.header}> 

            <div style={styles.logo}>
              <img
                src="/campanylogo.jpeg"
                alt="logo"
                style={styles.logoImg}
                crossOrigin="anonymous"
              />
            </div>

            <div style={styles.headerCenter}>
              <p style={styles.headerTitle}>
                HEALTH CHECK REGISTRATION PASS
              </p>
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.label}>Name:</div>
            <div style={styles.value}>
              {patientData?.patient_name || "ANIRUDDHA BISWAS"}
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.label}>Employee ID:</div>
            <div style={styles.value}>
              {patientData?.patient_excel_id || ""}
            </div>
          </div>

          <div style={styles.tests}>
            <span style={styles.label}>Tests Scheduled:</span>{" "}
            {patientData?.service ||
              ""}
          </div>

          <div style={styles.footer}>
            <div>DATE:{formatDate(patientData?.test_date) || ""}</div>
            <div>TIME:09:00 AM</div>
            <div>PACKAGE:144</div>
          </div>
        </div>

        {/* RIGHT */}
        <div style={styles.right}>
          <div style={styles.location}>
            {patientData?.camp?.location || " "}
          </div>
          <img
            src={patientData?.qr_code}
            alt="QR"
            style={styles.qr}
            crossOrigin="anonymous"
          />
          <div style={styles.qrText}>SCAN FOR CHECK-IN</div>
        </div>
      </div>

      <div ref={backRef} style={styles.back}>
        {/* LEFT SIDE */}
        <div style={styles.backLeft}>
          <div style={styles.backLogoWrap}>
            <img
              src="/campanylogo.jpeg"
              alt="XRai Logo"
              style={styles.backLogoImg}
              crossOrigin="anonymous"
            />
          </div>
          <div style={styles.backTopStrip} />

          <div style={styles.backContent}>
            <div style={styles.sectionTitle}>Patient Guidelines</div>
            <div style={styles.bullet}>• Carry this pass and follow staff instructions</div>
            <div style={styles.bullet}>• Rest before vitals, avoid smoking or caffeine</div>
            <div style={styles.bullet}>• Bring previous reports and spectacles (if any)</div>
            <div style={styles.bullet}>• Inform staff about pregnancy or medical conditions</div>

            <div style={{ marginTop: "6px" }}>
              <div style={styles.sectionTitle}>Company Contact Details</div>
              <div style={styles.contact}>Website: www.xraidigital.com</div>
              <div style={styles.contact}>Email: support@xraidigital.com</div>
              <div style={styles.contact}>Phone: +91 12345 67890</div>
            </div>
          </div>

          <div style={styles.backBottomStrip} />
        </div>

        {/* RIGHT PERFORATED AREA */}
        <div style={styles.backRight}>
          <div style={styles.location}>
            {patientData?.camp?.location || "Gurugram"}
          </div>

          <img
            src={patientData?.qr_code}
            alt="QR"
            style={styles.qr}
            crossOrigin="anonymous"
          />

          <div style={styles.qrText}>SCAN FOR CHECK-IN</div>
        </div>
      </div>

      <button style={styles.button} onClick={generateImage}>
        Generate & Download Boarding Pass
      </button>
    </>
  );
};

export default BoardingPass;